import { EnvironmentConfiguration, FeatureMode } from './environment.interface';

export const environment: EnvironmentConfiguration = {
  production: true,
  name: 'Dev 340B',
  api: 'https://rxparadigmdevbackend.azurewebsites.net/api',
  apiServicesUrl: 'https://dev-apiservices.rxparadigm.com/api',
  freshdeskUrl:
    'https://rxparadigm-org.myfreshworks.com/login/auth/1733421887652?client_id=451979510707337272&redirect_uri=https%3A%2F%2Frxparadigm-help.freshdesk.com%2Ffreshid%2Fcustomer_authorize_callback%3Fhd%3Dsupport.rxparadigm.com',
  reportingPlatform: {
    baseUrl: 'https://reports.rxparadigm.com/devtungsten',
    dashboard340B: '1-tungsten340b'
  },
  auth: {
    auth0Client: 'VAYjmIOvaZ9lY0lJgJaKQAmKylNPhXeJ',
    auth0Domain: 'login-dev.rxparadigm.com',
    audience: 'https://rxparadigmdevbackend.azurewebsites.net'
  },
  sessionTimeoutMinutes: 15,
  featureMode: FeatureMode.AUDIT_340B,
  enableAuditCustomerMedicaidIntegrations: true,
  enableDemoFeatures: true,
  enableMFPFunctionalFeatures: true,
  mongoChartsEmbed: {
    baseUrl: 'https://charts.mongodb.com/charts-tungsten-no-sql-dev-wofjdcq',
    claimVerificationChart: {
      id: '68e01261-3e06-400c-8549-dabc9e3543b4'
    },
    claimSourceTrendChart: {
      id: '68e01261-3e06-499d-8714-dabc9e3543b6'
    },
    verificationTrendChart: {
      id: '68e01261-3e06-43d8-8b33-dabc9e3543b8'
    },
    unverifiedClaimReasonChart: {
      id: '68e01261-3e06-46ff-8a8d-dabc9e3543bb'
    },
    mfpPharmacyDashboard: {
      id: '68e014ea-52bd-4330-85c1-a113b3e2c3ce'
    },
    rebatePharmacyDashboard: {
      id: '68e014c8-3e06-4da9-87ad-dabc9e49ac0c'
    }
  }
};
